import OurServicesCard from "../OurServicesComponents/OurServicesCard";

// Agriculture and Rural Transformation (ART) icons
import { MdChecklist } from "react-icons/md";
import { GiFarmer } from "react-icons/gi";
import { FaUtensils } from "react-icons/fa";
import { FaLeaf } from "react-icons/fa";
import { MdVerified } from "react-icons/md";

// Climate Action for Adaptation, Mitigation and Resilience  (CaAMRe)
import { FaHandshake } from "react-icons/fa6";
import { FaGlobeAsia } from "react-icons/fa";
import { BsFillUmbrellaFill } from "react-icons/bs";
import { BsCardChecklist } from "react-icons/bs";
import { PiTreeFill } from "react-icons/pi";
import { HiMiniPhoto } from "react-icons/hi2";

// Digital Transformation (D-TRANS)
import { IoIosPeople } from "react-icons/io";
import { FaPeopleGroup } from "react-icons/fa6";
import { IoIosLock } from "react-icons/io";
import { BiSolidCctv } from "react-icons/bi";
import { GrTechnology } from "react-icons/gr";

// Cities and Urban Development
import { FaTemperatureLow } from 'react-icons/fa';
import { WiRain } from 'react-icons/wi';
import { FaCity } from 'react-icons/fa';
import { MdLocationOn } from 'react-icons/md';

const ProjectList = () => {
    const OurServicesData=[
        {
            id: 1,
            image: "https://www.shutterstock.com/image-photo/smart-farming-concept-green-environment-600nw-2057472920.jpg",
            title: "Agriculture and Rural Transformation (ART)",
            focus:[
                {
                    icon:<MdChecklist />,
                    title:'Implementing Climate Actions',
                },
                {
                    icon:<GiFarmer />,
                    title:'Rural Industrialization and Farm Mechanization',
                },
                {
                    icon:<FaUtensils />,
                    title:'Farm-to-Fork , Agri-Food , value chain',
                },
                {
                    icon:<FaLeaf />,
                    title:'Reducing Short-Lived Climate Pollutants (SLCPs) in Agriculture Sector',
                },
                {
                    icon:<MdVerified />,
                    title:'Sustainable AgriCulture Innovation , Standards and Cirtifications',
                }
            ]
        },
        {
            id: 2,
            image: "https://t3.ftcdn.net/jpg/12/95/37/56/240_F_1295375682_3oFI7FKwttjkNSZLZzkw1azT27uVANVT.jpg",
            title: "Climate Action for Adaptation, Mitigation and Resilience  (CaAMRe)",
            focus:[
                {
                    icon:<FaHandshake />,
                    title:'Governance, Policy, Diplomacy and Negotiation',
                },
                {
                    icon:<FaGlobeAsia />,
                    title:'National, Sub-National and Local Climate Action',
                },
                {
                    icon:<BsFillUmbrellaFill />,
                    title:'Mitigation, Adaptation, Resilience Financing and Insurance',
                },
                {
                    icon:<BsCardChecklist />,
                    title:'Implementing the voluntary and compliance (Art 6.2, 6.4, 6.8) mitigation standards',
                },
                {
                    icon:<PiTreeFill />,
                    title:'Implementing the Climate and ESG Standards',
                },
                {
                    icon:<HiMiniPhoto />,
                    title:'Climate Science, Research, Education and Innovation',
                },
            ]
        },
        {
            id: 3,
            image: "https://media.gettyimages.com/id/1710786333/photo/artificial-intelligence-technology-concept-with-ai-text-on-electronic-circuit-board.jpg?s=612x612&w=0&k=20&c=juxM3C0JVYrWq39JDwHDjtkL3ZaLUnMdLdY6UrDOjGA=",
            title: "Digital Transformation (D-TRANS)",
            focus:[
                {
                    icon:<IoIosPeople />,
                    title:'Digital Transformation for Good Governance',
                },
                {
                    icon:<FaPeopleGroup />,
                    title:'Digital Inclusion - Leaving No One Behind',
                },
                {
                    icon:<IoIosLock />,
                    title:'Digital Responsibility for a safer and secure world',
                },
                {
                    icon:<BiSolidCctv />,
                    title:'Digital Monitoring , Reporting and Verification (MRV) for Integrity',
                },
                {
                    icon:<GrTechnology />,
                    title:'Smart Technologies & Science , Technology and Innovation',
                }
            ]
        },
        {
            id: 4,
            image: "https://media.gettyimages.com/id/590774561/photo/close-up-of-business-people-wind-turbine-model-and-houses-on-conference-table.jpg?s=612x612&w=0&k=20&c=QW4Mn1B35MQstXAqER4lOP5Gz1zKozYx3RzKJzbtCH4=",
            title: "Cities and Urban Development",
            focus:[
                {
                    icon:<FaTemperatureLow />,
                    title:'Decarbonization, Net-Zero and Climate Mitigation Actions',
                },
                {
                    icon:<WiRain />,
                    title:'Climate Adaptation, Resilient and Circular Development',
                },
                {
                    icon:<FaCity />,
                    title:'Sustainable, Climate Neutral and Smart Cities',
                },
                {
                    icon:<MdLocationOn />,
                    title:'Localisation of Nationally Determined Contributions (NDCs) and Sustainable Development Goals',
                },
                {
                    icon:<FaHandshake />,
                    title:'Local and Regional Development for International Cooperation',
                },
                {
                    icon:<HiMiniPhoto />,
                    title:'Financing Urban Risks, Transition and Transformation',
                },
            ]
        },
    ]
    return(
        <section style={{display:'flex',flexDirection:'column',gap:'20px'}}>
            {OurServicesData.map((data,index)=>(
                <div key={data?.id}>
                    <OurServicesCard
                        data={data}
                        right={index % 2 !== 0} // Alternate layout for odd/even index
                    />
                </div>
            ))}
        </section>
    )
}

export default ProjectList;